import _ from 'lodash';

import * as constants from './NotesLanding.constants';
import * as services from './NotesLanding.service';

const state = {
  notesList: [],

  courseIdx: 0,

  isRequest: false,
};

const mutations = {
  [constants.GET_NOTES_BOOKS_LIST_SUCCESS](state, notesList) {
    if (undefined !== notesList && null !== notesList) {
      //state.notesList = _.map(notesList, book => {
      //  book.i_downloadAddress = {
      //    generating: 'false',
      //    resData: {},
      //  };
      //  return book
      //});
      state.notesList = notesList;
    }
  },

  //[constants.GET_NOTES_DOWNLOAD_ADDRESS](state, payload) {
  //  if (undefined !== payload && null !== payload) {
  //    state.notesList = _.map(state.notesList, book => {
  //      if (book.course_id === payload.course_id) {
  //        return {
  //          ...book,
  //          i_downloadAddress: {
  //            generating: payload.generating,
  //            resData: payload.resData,
  //          }
  //        }
  //      } else {
  //        return book;
  //      }
  //    });
  //  }
  //},

  [constants.SET_COURSE_IDX](state, courseIdx) {
    state.courseIdx = courseIdx;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getNotesBooksList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getNotesBooksList(payload);
    commit(constants.GET_NOTES_BOOKS_LIST_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  //async generateFile({ commit }, payload) {
  //  commit(constants.GET_NOTES_DOWNLOAD_ADDRESS, {
  //    course_id: payload.course_id,
  //    generating: 'true',
  //    resData: {},
  //  });
  //  const res = await services.generateFile(payload);
  //  commit(constants.GET_NOTES_DOWNLOAD_ADDRESS, {
  //    course_id: payload.course_id,
  //    generating: 'done',
  //    resData: res.data.data,
  //  });
  //},

  //async generateFileRft({ commit }, payload) {
  //  commit(constants.SET_IS_REQUEST_STATUS, true);
  //  await services.generateFileRft(payload);
  //  commit(constants.DUMMY_MUTATION, {});
  //  commit(constants.SET_IS_REQUEST_STATUS, false);
  //},
};

const getters = {
  lstCoursesUniqbyCourseId: (state) => {
    let notesList = _.map(state.notesList, (book) => ({
      course_id: book.course_id,
      course_name: book.course_name,
      css_class_name: book.css_class_name,
      icon_path: book.icon_path,
      icon_url: book.icon_url,
      //i_downloadAddress: book.i_downloadAddress
    }));
    return _.uniqBy(notesList, 'course_id');
  },

  objNotesGroup: (state) => _.groupBy(state.notesList, (book) => book.course_id),

  lstNotesGroup: (state, getters) => {
    return _.map(getters.lstCoursesUniqbyCourseId, (course) => {
      const notesBooksList = getters.objNotesGroup[course.course_id];
      return {
        ...course,
        notesBooksListActive: _.filter(notesBooksList, (book) => !book.is_disable),
        notesBooksListDisabled: _.filter(notesBooksList, (book) => book.is_disable),
      };
    });
  },

  lstNotesGroupActive: (state, getters) => {
    let lstNotesGroupActive = _.filter(
      getters.lstNotesGroup,
      (course) => course.notesBooksListActive.length
    );
    return _.map(lstNotesGroupActive, (course, courseIdx) => ({
      ...course,
      courseIdx,
      notesBooksList: course.notesBooksListActive,
      notesBooksListActive: undefined,
    }));
  },

  lstNotesGroupDisabled: (state, getters) => {
    let lstNotesGroupDisabled = _.filter(
      getters.lstNotesGroup,
      (course) => course.notesBooksListDisabled.length
    );
    return _.map(lstNotesGroupDisabled, (course, courseIdx) => ({
      ...course,
      courseIdx,
      notesBooksList: course.notesBooksListDisabled,
      notesBooksListDisabled: undefined,
    }));
  },

  currentCourse: (state, getters) => {
    if (getters.lstNotesGroupActive && getters.lstNotesGroupActive.length) {
      return getters.lstNotesGroupActive[state.courseIdx];
    } else {
      return {};
    }
  },

  currentCourseAllBooks: (state, getters) => {
    if (getters.currentCourse.notesBooksList) {
      return _.map(getters.currentCourse.notesBooksList, (book) => book.book_id);
    } else {
      return [];
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
